import { createTheme } from '@mui/material/styles';

// Define the color palette
const palette = {
  primary: {
    main: '#f44336', // Red for important highlights and buttons
    contrastText: '#ffffff', // White text on red
  },
  secondary: {
    main: '#0D004A', // Title color
    contrastText: '#ffffff',
  },
  background: {
    default: '#ffffff', // White background
    paper: '#ffffff',
  },
  text: {
    primary: '#000000', // Black text
    secondary: '#0D004A', // For subtitles or secondary text
  },
};

// Create the theme
const theme = createTheme({
  palette,
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      lineHeight: 1.2,
      color: '#0D004A', // Title color
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      lineHeight: 1.3,
      color: '#0D004A',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#0D004A',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#0D004A',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: '#0D004A',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.6,
      color: '#0D004A',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      color: '#000000',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
      color: '#000000',
    },
    button: {
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'none',
      color: '#ffffff', // White text on red
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
          textTransform: 'none',
          fontWeight: 500,
        },
        contained: {
          backgroundColor: '#f44336', // Red background for important highlights
          color: '#ffffff', // White text
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          '&:hover': {
            backgroundColor: '#d32f2f',
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme;
